import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse, HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

let isRefreshing = false;

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const http = inject(HttpClient);

  // Skip auth for login, register, refresh endpoints
  if (req.url.includes('/customer/login') || req.url.includes('/customer/register') || req.url.includes('/customer/refresh')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isRefreshing) {
        const token = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');

        if (!token || !refreshToken) {
          return throwError(() => error);
        }

        const sessionId = getSessionIdFromToken(token);
        if (!sessionId) {
          return throwError(() => error);
        }

        isRefreshing = true;

        return http.post<any>(`${environment.authUrl}/customer/refresh`, { sessionId, refreshToken }).pipe(
          switchMap(res => {
            isRefreshing = false;
            if (res.success) {
              localStorage.setItem('accessToken', res.data.accessToken);
              localStorage.setItem('refreshToken', res.data.refreshToken);
              localStorage.setItem('user', JSON.stringify(res.data.user));

              const newReq = req.clone({
                setHeaders: { Authorization: `Bearer ${res.data.accessToken}` }
              });
              return next(newReq);
            }
            return throwError(() => error);
          }),
          catchError(refreshError => {
            isRefreshing = false;
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
            return throwError(() => refreshError);
          })
        );
      }

      return throwError(() => error);
    })
  );
};

function getSessionIdFromToken(token: string): string | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.jti ?? null;
  } catch {
    return null;
  }
}
